@if (isReady === true) {
  <div class="page-layout simple fullwidth">
    <mat-tab-group [(selectedIndex)]="selectedTab">
      @if (avatarChoice) {
        <mat-tab label="{{ 'gamification.gallery' | translate}}" >
          <app-gallery class="inner-scroll" (openCreature)="openCreature($event)"></app-gallery>
        </mat-tab>
      }
      <mat-tab label="{{ 'gamification.avatars' | translate}}">
        @if (selectedTab === 1) {
          <app-my-animals [selected]="selectedCreature"></app-my-animals>
        }
      </mat-tab>
    </mat-tab-group>
    <div class="credits">
      <div class="icon">
        <mat-icon svgIcon="credits" class="white-icon"></mat-icon>
      </div>{{userPoints}} {{ 'generic.credits' | translate}}
    </div>
    <app-buy-popup></app-buy-popup>
  </div>
}

@if (isReady === false) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
}